export function formatMoney(number) {
  // Coerce to a finite number; a missing/non-numeric value (e.g. a $0 balance
  // dropped by proto3/omitempty on the wire) must render as 0.00, never "NaN".
  const n = Number(number);
  return (Number.isFinite(n) ? n : 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function roundDown(number){
  return Number(Math.floor(number+'e'+2)+'e-'+2);
}
